import { useState, useMemo, useEffect } from "react"
import { Table, Button } from "react-bootstrap"
import { getOrderDetails } from "./helpers"

const DetailTable = ({
  data,
  setInfoDisplay,
  csvDownloadTracker,
  setCsvDownloadTracker,
  selected,
}) => {
  console.log(csvDownloadTracker)
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  })

  const sortData = useMemo(() => {
    let sortableItems = [...data]
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? -1 : 1
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? 1 : -1
        }
        return 0
      })
    }
    return sortableItems
  }, [data, sortConfig])

  const requestSort = (key) => {
    let direction = "ascending"
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending"
    }
    setSortConfig({ key, direction })
  }

  const formatNumber = (number) => {
    return number.toLocaleString()
  }

  const exportToCsv = () => {
    const csvRows = [
      [
        "Customer",
        "Entry Date",
        "Due Date",
        "Amount",
        "Aging",
        "Order Number",
        "Sales",
        "AM",
      ],
      ...sortData.map((item) => [
        `"${item[0]}"`,
        `"${item[1]}"`,
        `"${item[2]}"`,
        `"${item[3]}"`,
        `"${item[4]}"`,
        `"${item[5]}"`,
        `"${item[6]}"`,
        `"${item[7]}"`,
      ]),
    ]
    const csvString = csvRows.map((row) => row.join(",")).join("\n")

    const download_name = selected.customer.join('_AND_').replace(/ /g, "_")

    const blob = new Blob([csvString], { type: "text/csv" })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.setAttribute("hidden", "")
    a.setAttribute("href", url)
    a.setAttribute("download", `${download_name}_aging_summary.csv`)
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    setCsvDownloadTracker(false)
  }

  useEffect(() => {
    if (csvDownloadTracker === true) {
      exportToCsv()
    }
  }, [csvDownloadTracker])

  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th onClick={() => requestSort(0)}>Customer</th>
          <th onClick={() => requestSort(1)}>Entry Date</th>
          <th onClick={() => requestSort(2)}>Due Date</th>
          <th onClick={() => requestSort(3)}>Amount</th>
          <th onClick={() => requestSort(4)}>Aging</th>
          <th onClick={() => requestSort(5)}>Order Number</th>
          <th onClick={() => requestSort(6)}>Sales</th>
          <th onClick={() => requestSort(7)}>AM</th>
        </tr>
      </thead>
      <tbody>
        {sortData.map((item, index) => (
          <tr
            key={index}
            onClick={() => getOrderDetails(item[5], setInfoDisplay)}
          >
            <td>{item[0]}</td>
            <td>{item[1]}</td>
            <td>{item[2]}</td>
            <td>${formatNumber(item[3])}</td>
            <td>{item[4]}</td>
            <td>{item[5]}</td>
            <td>{item[6]}</td>
            <td>{item[7]}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}

export default DetailTable
